import React from 'react'

import { Form, Col } from '_zari/core'

const CodigoFormGroup = ({ onChange, value }) => {
  return (
    <Form.Group>
      <Form.Label text='CÓDIGO' htmlFor='input-codigo' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Form.InputText id='input-codigo' name='input-codigo' onChange={onChange} value={value} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
